module.exports = __webpack_public_path__ + "static/img/13.6443883.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/sp/13.png
// module id = APAV
// module chunks = 0